// eslint-disable-next-line import/no-cycle
import router from '@/app/router';

// Home, LoanApp
export default function notLoanApp({ to, next, store }) {
	const { loanStatus } = store.state.centrifugeStatus;

	if (to.name === 'loan-app' && !loanStatus) {
		return router.push({ name: 'home' });
	}
	if (!loanStatus) {
		return next({ name: 'home' });
	}

	const ignoredStatuses = ['created'];

	if (loanStatus && !ignoredStatuses.includes(loanStatus)) {
		return router.push({ name: 'info-status' });
	}

	return next();
}
